module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Android-6cb902afb1899a87597e0dd3e3e1eef5.svg";